import React from 'react'
import { TextSM } from '../../../Components/Text/NormalText';
import NuDate from '../../../Components/Utils/NuDate';
import { Link } from 'react-router-dom';
import ViewMoreTeam from './ViewMoreTeam';
import { NewPill } from '../../../Components/Utils/StatusPills';
import { Image, Phone, User } from 'lucide-react';
import { FaUserTie } from 'react-icons/fa';
import Email from '../../../Components/Icons/Email';

function TeamCard({ item,getData }) {
   
    return (
        <div className="w-full bg-white rounded-xl shadow border border-gray-200 p-4">
  {/* Header */}
  <div className="flex items-start justify-between mb-4">
    <div>
      <div className="flex items-center justify-between gap-3 mb-2">
                 <div className='w-20 h-20 rounded-full overflow-hidden bg-gray-100 border border-gray-300 flex items-center justify-center'>
            {item.image?.file ? (
              <img src={item.image?.file} alt={item.name} className="w-20 h-20 object-cover rounded-md" />
            ) : (
               item?.name[0]
              // <span className='text-2xl font-medium text-blue-500 '><Image size={14}/></span>
            )}
          </div>
        
      </div>
      
      <h3 className="text-lg font-semibold text-gray-800">
        <Link
          to={`/teammember/team/view/${item?.id}`}
          state={{ data: item }}
          className="hover:text-blue-600"
        >
          {item?.name}
        </Link>
      </h3>
    </div>
    <div className={`text-xs px-3 py-1 rounded-full w-fit ${
    item.status === "Active" 
      ? "bg-green-100 text-green-700" 
      : "bg-yellow-100 text-yellow-700"
  }`}>
    {item?.status}
  </div>
    <ViewMoreTeam 
      id={item?.id}
      getData={getData}
      data={item} 
    />
    
  </div>

  {/* Contact Info */}
  <div className="space-y-3 mb-4">
    {/* <div className="flex items-center gap-2 text-sm text-gray-700">
      <User size={14} className="text-gray-500" />
      <div>
        <p className="text-xs text-gray-500">Contact Person</p>
        <p>{item?.name || "-"}</p>
      </div>
    </div> */}
    <div className="flex items-center gap-2 text-sm text-gray-700">
      <Email size={14} className="text-gray-500" />
      <div>
        <p className="text-xs text-gray-500">Email</p>
        <p>{item?.email || "-"}</p>
      </div>
    </div>
    
    <div className="flex items-center gap-2 text-sm text-gray-700">
      <FaUserTie size={14} className="text-gray-500" /> 
      <div>
        <p className="text-xs text-gray-500">Designation</p>
        <p>{item?.designation || "-"}</p>
      </div>
    </div>
    
    <div className="flex items-center gap-2 text-sm text-gray-700">
      <Phone size={14} className="text-gray-500" />
      <div>
        <p className="text-xs text-gray-500">Phone</p>
        <p>{item?.phoneWithCC || "-"}</p>
      </div>
    </div>
  </div>

  {/* Status */}
  
</div>
    );
  }
export default TeamCard